import ConfigurationAuthStore from './ConfigurationAuthStore'
import { i18nMergeLanguage } from '@/i18n/i18n'
import store from '@/store'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    configurationLoaded: false,
    configuration: {}
  },
  getters: {
    configurationLoadingCompleted (state, getters) {
      return state.configurationLoaded
    },
    applications (state, getters) {
      return state.configuration.applications
    },
    version (state, getters) {
      return state.configuration.version
    },
    tour (state, getters, rootState, rootGetters) {
      const authApps = rootGetters['configurationStore/auth/applications']
      const tourConfig = state.configuration.tour || {}
      for (const root in tourConfig) {
        for (const appId in authApps) {
          const appTours = authApps[appId].tour || {}
          tourConfig[root].tour = {
            ...tourConfig[root].tour,
            ...appTours
          }
        }
      }
      return tourConfig
    },
    maintenance (state, getters) {
      return state.configuration.maintenance
    },
    uploadValidation (state) {
      return state.configuration.fileUpload || {}
    },
    schema (state) {
      return state.configuration.schema || {}
    },
    DOMPurify (state) {
      return state.configuration.DOMPurify || {}
    },
    historyTabs (state) {
      return state.configuration.historyTabs || {}
    },
    theme (state) {
      return state.configuration.theme || 'default'
    },
    themesAllowed (state) {
      return state.configuration.themesAllowed || ['default']
    }
  },
  mutations: {
    setConfiguration: function (state, configuration) {
      state.configuration = configuration
      state.configurationLoaded = true
    }
  },
  actions: {
    loadConfiguration (context) {
      // determine configuration to be loaded
      const url = window.envmap.VUE_APP_AGILIS_APPLICATION_ID
        ? Vue.axios.agilisUrlConfigurationForApplication(window.envmap.VUE_APP_AGILIS_APPLICATION_ID)
        : Vue.axios.agilisUrlConfigurationMinified()

      // 'this' is the store, 'context' is the store module
      return Vue.axios
        .get(url, Vue.axios.agilisRequestConfig(url, window.envmap.VUE_APP_AGILIS_CONFIGURATOR_ENDPOINT))
        .then((response) => {
          const config = response.data
          context.commit('setConfiguration', config)
          // load server side messages
          for (const lang in config.i18n.lang) {
            i18nMergeLanguage(lang, config.i18n.lang[lang])
            Vue.prototype.$debug(`merged language ${lang}`)
          }
          Vue.prototype.$debug('configuration loaded - apps ' + Object.keys(config.applications))

          store.dispatch('userDataStore/calculatePrivileges')
        })
        .catch((error) => {
          context.dispatch('notificationStore/notifyError', error, { root: true })
        })
    },

    setConfiguration (context, config) {
      context.commit('setConfiguration', config)
    }
  },
  modules: {
    auth: ConfigurationAuthStore
  }
}
